import * as atatus from 'atatus-spa';
export var configureMonitoring = function (key, whitelistUrls, customData, env) {
    if (customData === void 0) { customData = {}; }
    atatus
        .config(key, {
        console: true,
        customData: customData,
        whitelistUrls: whitelistUrls,
    })
        .install();
    atatus.setTags([env]);
    return atatus;
};
